import React, { useState, useRef } from "react";
import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  Text,
  Center,
  Stack,
  Textarea,
  useBreakpointValue,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { useParams } from 'react-router-dom';
import axios from 'axios';



const Questionnaire = () => {
  const [step, setStep] = useState(1)
  const [progress, setProgress] = useState(0)

  const [active1A, setActive1A] = useState(false)
  const [active1B, setActive1B] = useState(false)
  const [active1C, setActive1C] = useState(false)
  const [active1D, setActive1D] = useState(false)

  const [active2A, setActive2A] = useState(false)
  const [active2B, setActive2B] = useState(false)
  const [active2C, setActive2C] = useState(false)
  const [active2D, setActive2D] = useState(false)

  const [active3A, setActive3A] = useState(false)
  const [active3B, setActive3B] = useState(false)
  const [active3C, setActive3C] = useState(false)
  const [active3D, setActive3D] = useState(false)
  const [active3E, setActive3E] = useState(false)

  const [active4A, setActive4A] = useState(false)
  const [active4B, setActive4B] = useState(false)
  const [active4C, setActive4C] = useState(false)
  const [active4D, setActive4D] = useState(false)
  const [active4E, setActive4E] = useState(false)

  const [active5A, setActive5A] = useState(false)
  const [active5B, setActive5B] = useState(false)
  const [active5C, setActive5C] = useState(false)
  const [active5D, setActive5D] = useState(false)

  const [active6A, setactive6A] = useState(false)
  const [active6B, setactive6B] = useState(false)

  const [active7A, setactive7A] = useState(false)
  const [active7B, setactive7B] = useState(false)
  const [active7C, setactive7C] = useState(false)
  const [active7D, setactive7D] = useState(false)
  const [active7E, setactive7E] = useState(false)

  const [active8A, setactive8A] = useState(false)
  const [active8B, setactive8B] = useState(false)
  const [active8C, setactive8C] = useState(false)
  const [active8D, setactive8D] = useState(false)
  const [active8E, setactive8E] = useState(false)
  const [active8F, setactive8F] = useState(false)

  const [active9A, setactive9A] = useState(false)
  const [active9B, setactive9B] = useState(false)
  const [active9C, setactive9C] = useState(false)
  const [active9D, setactive9D] = useState(false)
  const [active9E, setactive9E] = useState(false)

  const [active10A, setactive10A] = useState(false)
  const [active10B, setactive10B] = useState(false)

  const [active11A, setactive11A] = useState(false)
  const [active11B, setactive11B] = useState(false)
  const [active11C, setactive11C] = useState(false)
  const [active11D, setactive11D] = useState(false)

  const [active12A, setactive12A] = useState(false)
  const [active12B, setactive12B] = useState(false)
  const [active12C, setactive12C] = useState(false)
  const [active12D, setactive12D] = useState(false)

  const [active13A, setactive13A] = useState(false)
  const [active13B, setactive13B] = useState(false)
  const [active13C, setactive13C] = useState(false)
  const [active13D, setactive13D] = useState(false)

  const [active14A, setactive14A] = useState(false)
  const [active14B, setactive14B] = useState(false)

  const [active15A, setactive15A] = useState(false)
  const [active15B, setactive15B] = useState(false)
  const [active15C, setactive15C] = useState(false)
  const [active15D, setactive15D] = useState(false)
  const [active15E, setactive15E] = useState(false)

  const [active16A, setactive16A] = useState(false)
  const [active16B, setactive16B] = useState(false)
  const [active16C, setactive16C] = useState(false)
  const [active16D, setactive16D] = useState(false)

  const [active17A, setactive17A] = useState(false)
  const [active17B, setactive17B] = useState(false)
  const [active17C, setactive17C] = useState(false)
  const [active17D, setactive17D] = useState(false)
  const [active17E, setactive17E] = useState(false)

  const [active18A, setactive18A] = useState(false)
  const [active18B, setactive18B] = useState(false)
  const [active18C, setactive18C] = useState(false)

  const [active19A, setactive19A] = useState(false)
  const [active19B, setactive19B] = useState(false)
  const [active19C, setactive19C] = useState(false)

  const [active20A, setactive20A] = useState(false)
  const [active20B, setactive20B] = useState(false)
  const [active20C, setactive20C] = useState(false)
  const [active20D, setactive20D] = useState(false)

  const [active21A , setactive21A] = useState(false)
  const [active21B , setactive21B] = useState(false)
  const [active21C , setactive21C] = useState(false)
  const [active21D , setactive21D] = useState(false)

  const [active22A , setactive22A] = useState(false)
  const [active22B , setactive22B] = useState(false)
  const [active22C , setactive22C] = useState(false)
  const [active22D , setactive22D] = useState(false)
  const [active22E , setactive22E] = useState(false)

  const [active23A , setactive23A] = useState(false)
  const [active23B , setactive23B] = useState(false)
  const [active23C , setactive23C] = useState(false)
  const [active23D , setactive23D] = useState(false)

  const [active24A , setactive24A] = useState(false)
  const [active24B , setactive24B] = useState(false)
  const [active24C , setactive24C] = useState(false)
  const [active24D , setactive24D] = useState(false)

  const [active25A , setactive25A] = useState(false)
  const [active25B , setactive25B] = useState(false)
  const [active25C , setactive25C] = useState(false)
  const [active25D , setactive25D] = useState(false)

  const [active26A , setactive26A] = useState(false)
  const [active26B , setactive26B] = useState(false)

  const [active27A , setactive27A] = useState(false)
  const [active27B , setactive27B] = useState(false)
  const [active27C , setactive27C] = useState(false)
  const [active27D , setactive27D] = useState(false)
  const [active27E , setactive27E] = useState(false)
  const [active27F , setactive27F] = useState(false)

  const [active28A , setactive28A] = useState(false)
  const [active28B , setactive28B] = useState(false)
  const [active28C , setactive28C] = useState(false)
  const [active28D , setactive28D] = useState(false)

  const [active29A , setactive29A] = useState(false)
  const [active29B , setactive29B] = useState(false)
  const [active29C , setactive29C] = useState(false)

  const [active30A , setactive30A] = useState(false)
  const [active30B , setactive30B] = useState(false)
  const [active30C , setactive30C] = useState(false)

  //const [active31A , setactive31A] = useState(false)

  const [textAreaValue1, setTextAreaValue1] = useState('')
  const [textAreaValue3, setTextAreaValue3] = useState('')
  const [textAreaValue4, setTextAreaValue4] = useState('')
  const [textAreaValue7, setTextAreaValue7] = useState('')
  const [textAreaValue8, setTextAreaValue8] = useState('')
  const [textAreaValue12, setTextAreaValue12] = useState('')
  const [textAreaValue13, setTextAreaValue13] = useState('')
  const [textAreaValue15, setTextAreaValue15] = useState('')
  const [textAreaValue22, setTextAreaValue22] = useState('')
  const [textAreaValue31, setTextAreaValue31] = useState('')

  let handleInputChange1 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue1(inputValue)
  }
  let handleInputChange3 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue3(inputValue)
  }
  let handleInputChange4 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue4(inputValue)
  }
  let handleInputChange7 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue7(inputValue)
  }
  let handleInputChange8 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue8(inputValue)
  }
  let handleInputChange12 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue12(inputValue)
  }
  let handleInputChange13 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue13(inputValue)
  }
  let handleInputChange15 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue15(inputValue)
  }
  let handleInputChange22 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue22(inputValue)
  }
  let handleInputChange31 = (e) => {
    let inputValue = e.target.value
    setTextAreaValue31(inputValue)
  }

  const buttonSize = useBreakpointValue({ base: "sm", md: "md" });
  const headingSize = useBreakpointValue({ base: "md", md: "xl" });
  const textSize = useBreakpointValue({ base: "md", md: "lg" });

  const { token } = useParams();

  const toast = useToast();
  const toastIdRef = useRef()

  /* const location = useLocation();
  const [registrationData, setRegistrationData] = useState(null);
  useEffect(() => {
    if (location.state && location.state.registrationData) {
      setRegistrationData(location.state.registrationData);
    }
  }, [location.state]); */

  const handleSubmit = async () => {
    const surveyData = {
      1: {
        "Q": "1. Comment gérez-vous principalement votre argent ?",
        "R": active1A ? "A. En espèces" : active1B ? "B. Par Mobile Money" : active1C ? "C. Par compte bancaire" : `D. Autre: ${textAreaValue1}`
      },
      2: {
        "Q": "2. Combien de fois utilisez-vous de l'argent liquide par semaine ?",
        "R": active2A ? "A. Jamais" : active2B ? "B. 1 à 2 fois" : active2C ? "3 à 5 fois" : "D. Tous les jours"
      },
      3: {
        "Q": "3. Quelle est votre principale méthode pour payer vos achats ?",
        "R": active3A ? "A. Espèces" : active3B ? "B. Mobile Money" : active3C ? "C. Carte bancaire" : active3D ? "D. Application bancaire mobile" : `E. Autre: ${textAreaValue3}`
      },
      4: {
        "Q": "4. Où utilisez-vous principalement l'argent liquide ?",
        "R": active4A ? "A. Marché" : active4B ? "B. Magasins (Boutiques)" : active4C ? "C. Transport" : active4D ? "D. Paiement de services (eau, électricité, etc.)" : `E. Autre: ${textAreaValue4}`
      },
      5: {
        "Q": "5. Avez-vous déjà utilisé un QR Code pour payer un commerçant ?",
        "R": active5A ? "A. Oui, régulièrement" : active5B ? "B. Oui, occasionnellement" : active5C ? "C. Non, jamais" : "D. Je ne sais pas ce que c’est"
      },
      6: {
        "Q": "6. Avez-vous un compte Mobile Money actif ?",
        "R": active6A ? "A. Oui" : "B. Non"
      },
      7: {
        "Q": "7. Quel service Mobile Money utilisez-vous le plus souvent ?",
        "R": active7A ? "A. Orange Money" : active7B ? "B. MTN Mobile Money" : active7C ? "C. Moov Money" : active7D ? "D. Wave" : `E. Autre: ${textAreaValue7}`
      },
      8: {
        "Q": "8. Pourquoi utilisez-vous principalement Mobile Money ?",
        "R": `${active8A ? "A. Envoyer de l’argent <br />" : ""}  ${active8B ? "B. Recevoir de l’argent <br />" : ""}  ${active8C ? "C. Payer des factures <br />" : ""}  ${active8D ? "D. Acheter du crédit téléphonique <br />" : ""}  ${active8E ? "E. Épargner <br />" : ""}  ${active8F ? `F. Autre: ${textAreaValue8}` : ""}`
        //"R": active8A ? "A. Envoyer de l’argent" : active8B ? "B. Recevoir de l’argent" : active8C ? "C. Payer des factures" : active8D ? "D. Acheter du crédit téléphonique" : active8E ? "E. Épargner" : `F. Autre: ${textAreaValue8}`
      },
      9: {
        "Q": "9. Quel est le principal problème que vous rencontrez avec Mobile Money ?",
        "R": active9A ? "A. Frais élevés" : active9B ? "B. Transactions échouées" : active9C ? "C. Mauvais service client" : active9D ? "D. Limitations du service" : "E. Aucun problème"
      },
      10: {
        "Q": "10. Quel type de téléphone utilisez-vous principalement ?",
        "R": active10A ? "A. Smartphone (téléphone connecté à Internet)" : "B. Téléphone simple (pas d’accès Internet)"
      },
      11: {
        "Q": "11. À quelle fréquence avez-vous accès à Internet mobile ?",
        "R": active11A ? "A. Tous les jours" : active11B ? "B. Quelques fois par semaine" : active11C ? "C. Rarement" : "D. Jamais"
      },
      12: {
        "Q": "12. Si vous perdez votre connexion Internet, comment préférez-vous accéder à votre compte ?",
        "R": active12A ? "A. Par code USSD (*123#)" : active12B ? "B. Par SMS" : active12C ? "C. Par appel téléphonique" : `D. Autre: ${textAreaValue12}`
      },
      13: {
        "Q": "13. Quel fournisseur Internet utilisez-vous principalement ?",
        "R": active13A ? "A. Orange" : active13B ? "B. MTN" : active13C ? "C. Moov" : `D. Autre: ${textAreaValue13}`
      },
      14: {
        "Q": "14. Avez-vous un compte bancaire aujourd'hui ?",
        "R": active14A ? "A. Oui" : "B. Non"
      },
      15: {
        "Q": "15. Pourquoi n'avez-vous pas de compte bancaire ?",
        "R": active15A ? "A. Frais trop élevés" : active15B ? "B. Manque de confiance" : active15C ? "C. Démarches compliquées" : active15D ? "D. Pas besoin" : active15E ? `E. Autre: ${textAreaValue15}` : ""
      },
      16: {
        "Q": "16. À quelle fréquence l’utilisez-vous ?",
        "R": active16A ? "A. Plusieurs fois par semaine" : active16B ? "B. Une fois par semaine" : active16C ? "C. Moins d'une fois par mois" : "D. Jamais"
      },
      17: {
        "Q": "17. Comment épargnez-vous votre argent ?",
        "R": active17A ? "A. Espèces cachées à la maison" : active17B ? "B. Compte d’épargne bancaire" : active17C ? "C. Mobile Money" : active17D ? "D. Groupe d’épargne (tontine)" : "E. Je n’épargne pas"
      },
      18: {
        "Q": "18. Seriez-vous intéressé par un service d’épargne automatique via votre téléphone ?",
        "R": active18A ? "A. Oui, certainement" : active18B ? "B. Peut-être" : "C. Non"
      },
      19: {
        "Q": "19. Seriez-vous intéressé par une tontine digitale et sécurisée ?",
        "R": active19A ? "A. Oui" : active19B ? "B. Non" : "C. Peut-être"
      },
      20: {
        "Q": "20. Avez-vous déjà contracté un prêt ?",
        "R": active20A ? "A. Oui, auprès d'une banque" : active20B ? "B. Oui, via Mobile Money" : active20C ? "C. Oui, auprès d’un proche ou d’une tontine" : "D. Non, jamais"
      },
      21: {
        "Q": "21. Si vous pouviez demander un prêt par téléphone, qu'est-ce qui serait le plus important pour vous ?",
        "R": active21A ? "A. Rapidité d'obtention" : active21B ? "B. Taux d'intérêt faible" : active21C ? "C. Pas besoin de garantie" : "D. Flexibilité de remboursement"
      },
      22: {
        "Q": "22. Quel type de prêt vous intéresserait le plus ?",
        "R": active22A ? "A. Petit prêt d’urgence" : active22B ? "B. Prêt pour lancer ou développer un projet" : active22C ? "C. Prêt pour frais scolaires ou santé" : active22D ? "D. Prêt immobilier" : `E. Autre: ${textAreaValue22}`
      },
      23: {
        "Q": "23. Quelle est votre principale inquiétude concernant les services financiers digitaux ?",
        "R": active23A ? "A. Vol ou perte d’argent" : active23B ? "B. Vol de données personnelles" : active23C ? "C. Difficulté d’avoir de l’assistance en cas de problème" : "D. Difficulté d’utilisation"
      },

      24: {
        "Q": "24. Quel type de support client préférez-vous ?",
        "R": active24A ? "A. Chat dans l'application" : active24B ? "B. Numéro d’appel gratuit" : active24C ? "C. Assistance par WhatsApp" : "D. Pouvoir se déplacer en agence"
      },

      25: {
        "Q": "25. Voir vos transactions en temps réel est-il important pour vous ?",
        "R": active25A ? "A. Très important" : active25B ? "B. Important" : active25C ? "C. Peu important" : "D. Pas important du tout"
      },

      26: {
        "Q": "26. Préférez-vous des frais bancaires ?",
        "R": active26A ? "A. Fixes et transparents, même s’ils sont un peu élevés" : "B. Très bas mais variables selon les opérations"
      },
      27: {
        "Q": "27. Quels services aimeriez-vous retrouver dans une application bancaire ?",
        "R": `${active27A ? "A. Paiement de factures (eau, électricité, Internet) <br />" : ""}  ${active27B ? "B. Transfert d’argent international <br />" : ""}  ${active27C ? "C. Cagnotte collective (ex. mariage, fêtes) <br />" : ""}  ${active27D ? "D. Achat de crédit téléphonique <br />" : ""}  ${active27E ? "E. Assurance santé ou scolaire <br />" : ""}  ${active27F ? "F. Récompenses (programme fidélité)" : ""}`,
        //"R": active27A ? "A. Paiement de factures (eau, électricité, Internet)" : active27B ? "B. Transfert d’argent international" : active27C ? "C. Cagnotte collective (ex. mariage, fêtes)" : active27D ? "D. Achat de crédit téléphonique" : active27E ? "E. Assurance santé ou scolaire" : "Récompenses (programme fidélité)"
      },
      28: {
        "Q": "28. Quelle est la priorité la plus importante pour vous dans une banque mobile ?",
        "R": active28A ? "A. Facilité d’utilisation" : active28B ? "B. Coûts réduits" : active28C ? "C. Rapidité d’exécution" : "D. Sécurité maximale"
      },
      29: {
        "Q": "29. Seriez-vous prêt à recommander un service bancaire digital à votre entourage ?",
        "R": active29A ? "A. Oui, sans hésiter" : active29B ? "B. Oui, après avoir testé longtemps" : "C. Non"
      },
      30: {
        "Q": "30. Selon vous, que deviendra l’utilisation du cash dans votre pays ?",
        "R": active30A ? "A. Le cash restera dominant" : active30B ? "B. Le cash va diminuer au profit du mobile" : "C. Le cash va presque disparaître"
      },
      31: {
        "Q": "31. Selon vous, que devrait absolument offrir une nouvelle banque mobile pour vous convaincre de l’utiliser ?",
        "R": textAreaValue31
      }
    };

    try {
      toastIdRef.current = toast({
        icon: <Spinner />,       
        title: "Envoie des réponses en cours",
        description: "Veuillez patienter...",
        status: "loading",
        duration: null,
        isClosable: true, 
      });
      const response = await axios.put('https://cicabank.com/survey', surveyData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      if (response.status === 200) {
        if (toastIdRef.current) {
          toast.update(toastIdRef.current, {
            title: "Envoie réussie",
            description: "Vos réponses ont été bien enregistrées.",
            status: "success",
            duration: 5000,
            isClosable: true,
          })
        }
        setStep(step + 1)
        setProgress(progress + 5)
      }
    } catch (error) {
      toast.update(toastIdRef.current, {
        title: "Erreur lors de l'envoie",
        description: "Une erreur s'est produite lors de l'envoie de vos réponses. Veuillez réessayer.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      console.error('Error submitting survey data', error);
    }
  };

  const Intro = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="bold" mb="6%" color={'black'}>
          Votre inscription a bien été prise en compte !
        </Heading>
        <Text w="100%" fontSize={textSize} textAlign={'justify'} fontWeight="normal" mb="6%" color={'black'} px={4}>
          {/* Cicabank est une banque en ligne, sans agences physiques, conçue pour transformer le secteur bancaire en Afrique de l’Ouest. Notre objectif est de moderniser la manière dont les gens gèrent leur argent, en offrant des services entièrement numériques qui permettent à nos utilisateurs d’effectuer toutes leurs transactions depuis leur téléphone, sans avoir besoin de transporter de l’argent liquide. */}
          Cicabank, une banque 100 % en ligne, est conçue pour révolutionner le système bancaire en Afrique de l’Ouest en faisant de vos besoins notre priorité absolue.
          <br /> <br />
          {/* Nous voulons également promouvoir un système où les paiements du quotidien deviennent simples, rapides et sécurisés, que ce soit pour régler un achat, envoyer de l’argent à un proche ou payer des factures. Avec Cicabank, les frontières entre les pays de la sous-région ouest-africaine ne seront plus un obstacle : vous pourrez effectuer des transactions entre pays facilement et à moindre coût. */}
          Avec notre application bancaire innovante, effectuez toutes vos transactions bancaires sans limitation de frontières, sans argent liquide, de manière rapide et sécurisée. 
          <br /> <br />
          {/* Votre avis est important pour nous aider à construire une banque adaptée à vos attentes. Merci de répondre à ce questionnaire. */}
          Aidez-nous à mieux comprendre vos besoins en répondant au questionnaire suivant.
        </Text>
  
        <Box mt={4} align={'center'}>
              <ButtonGroup mt={4} spacing={10}>
                <Button
                    bg={'#FFD700'}
                    rounded={'full'}
                    colorScheme="yellow"
                    size={buttonSize}
                      onClick={() => {
                      setStep(step + 1)
                      //if (step !== 1) setProgress(progress + 5)
                    }}
                  >
                    Répondre au questionnaire
                  </Button>
              </ButtonGroup>
            </Box>
      </>
    )
  }
  
  const Congrats = () => {
    return (
      <Box textAlign="center" py={10} px={6}>
        <CheckCircleIcon boxSize={'50px'} color={'#FFD700'} />
        <Heading as="h2" size={headingSize} mt={10} mb={2} color='black'>
          Vos réponses ont bien été enregistrées. 
        </Heading>
        <Text color='black' mt={10} fontSize={textSize}>
          Merci d'avoir participé à notre questionnaire. Nous vous recontacterons bientôt.
        </Text>
      </Box>
    )
  }

  /* const Question1 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Quel est votre principal problème avec les banques actuelles ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active1A) {
                  setActive1A(true)
                  setActive1B(false)
                  setActive1C(false)
                  setActive1D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Les agences sont trop loin</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active1B) {
                  setActive1A(false)
                  setActive1B(true)
                  setActive1C(false)
                  setActive1D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Les frais bancaires sont trop élevés</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active1C) {
                  setActive1A(false)
                  setActive1B(false)
                  setActive1C(true)
                  setActive1D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Les transactions entre pays ouest-africains sont compliquées ou coûteuses</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active1D) {
                  setActive1A(false)
                  setActive1B(false)
                  setActive1C(false)
                  setActive1D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Je dois utiliser de l’argent liquide pour presque tout</Text>
              </Center>
            </Button>
          </Stack>
        </Center>

        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active1A || active1B || active1C || active1D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active2A || active2B || active2C || active2D) setProgress(10)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  } */
  
  const Question2 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Comment payez-vous le plus souvent ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active2A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active2A) {
                  setActive2A(true)
                  setActive2B(false)
                  setActive2C(false)
                  setActive2D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Avec de l’argent liquide</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active2B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active2B) {
                  setActive2A(false)
                  setActive2B(true)
                  setActive2C(false)
                  setActive2D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Avec mobile money (MTN, Orange Money, etc.)</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active2C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active2C) {
                  setActive2A(false)
                  setActive2B(false)
                  setActive2C(true)
                  setActive2D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Avec une carte bancaire</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active2D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active2D) {
                  setActive2A(false)
                  setActive2B(false)
                  setActive2C(false)
                  setActive2D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Avec plusieurs méthodes combinées</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active2A || active2B || active2C || active2D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active3A || active3B || active3C || active3D) setProgress(15)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  /* const Question3 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Si vous pouviez éviter d’utiliser de l’argent liquide, seriez-vous intéressé par une solution numérique ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active3A) {
                  setActive3A(true)
                  setActive3B(false)
                  setActive3C(false)
                  setActive3D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, cela rendrait tout plus pratique</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active3B) {
                  setActive3A(false)
                  setActive3B(true)
                  setActive3C(false)
                  setActive3D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, mais seulement si c’est facile à utiliser</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active3C) {
                  setActive3A(false)
                  setActive3B(false)
                  setActive3C(true)
                  setActive3D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Peut-être, cela dépend des options proposées</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active3D) {
                  setActive3A(false)
                  setActive3B(false)
                  setActive3C(false)
                  setActive3D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Non, je préfère l’argent liquide</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    setProgress(progress - 5)
                    //setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active3A || active3B || active3C || active3D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active4A || active4B || active4C || active4D) setProgress(20)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question4 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Avez-vous déjà eu des difficultés pour envoyer ou recevoir de l’argent depuis un autre pays de la sous-région ouest-africaine ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active4A) {
                  setActive4A(true)
                  setActive4B(false)
                  setActive4C(false)
                  setActive4D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, c’est souvent cher et compliqué</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active4B) {
                  setActive4A(false)
                  setActive4B(true)
                  setActive4C(false)
                  setActive4D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, mais j’utilise des services alternatifs comme mobile money</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active4C) {
                  setActive4A(false)
                  setActive4B(false)
                  setActive4C(true)
                  setActive4D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Non, je n’ai pas ce problème</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active4D) {
                  setActive4A(false)
                  setActive4B(false)
                  setActive4C(false)
                  setActive4D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Non, je n’ai jamais essayé</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active4A || active4B || active4C || active4D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active5A || active5B || active5C || active5D) setProgress(25)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  } */
  
  const Question5 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Avez-vous déjà utilisé un QR Code pour payer un commerçant ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active5A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active5A) {
                  setActive5A(true)
                  setActive5B(false)
                  setActive5C(false)
                  setActive5D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, régulièrement</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active5B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active5B) {
                  setActive5A(false)
                  setActive5B(true)
                  setActive5C(false)
                  setActive5D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, occasionnellement</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active5C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active5C) {
                  setActive5A(false)
                  setActive5B(false)
                  setActive5C(true)
                  setActive5D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Non, jamais</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active5D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active5D) {
                  setActive5A(false)
                  setActive5B(false)
                  setActive5C(false)
                  setActive5D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Je ne sais pas ce que c’est</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(20)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active5A || active5B || active5C || active5D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active6A || active6B || active6C || active6D) setProgress(30)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question6 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Avez-vous un compte Mobile Money actif ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active6A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active6A) {
                  setactive6A(true)
                  setactive6B(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active6B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active6B) {
                  setactive6A(false)
                  setactive6B(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Non</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(25)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active6A || active6B)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active7A || active7B || active7C || active7D) setProgress(35)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  /* const Question7 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Connaissez-vous les paiements par QR code ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active7A) {
                  setactive7A(true)
                  setactive7B(false)
                  setactive7C(false)
                  setactive7D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, je les utilise déjà</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active7B) {
                  setactive7A(false)
                  setactive7B(true)
                  setactive7C(false)
                  setactive7D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, mais je ne les ai jamais essayés</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active7C) {
                  setactive7A(false)
                  setactive7B(false)
                  setactive7C(true)
                  setactive7D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Non, je ne connais pas cette méthode</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active7D) {
                  setactive7A(false)
                  setactive7B(false)
                  setactive7C(false)
                  setactive7D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Non, et je ne pense pas en avoir besoin</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(30)
                    setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active7A || active7B || active7C || active7D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active8A || active8B || active8C || active8D) setProgress(40)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question8 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Si plusieurs options de paiement étaient proposées, laquelle utiliseriez-vous le plus souvent ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active8A) {
                  setactive8A(true)
                  setactive8B(false)
                  setactive8C(false)
                  setactive8D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Paiements par QR code dans les magasins</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active8B) {
                  setactive8A(false)
                  setactive8B(true)
                  setactive8C(false)
                  setactive8D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Envoi direct d’argent à un proche ou un commerçant</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active8C) {
                  setactive8A(false)
                  setactive8B(false)
                  setactive8C(true)
                  setactive8D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Paiement de factures comme l’eau ou l’électricité</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active8D) {
                  setactive8A(false)
                  setactive8B(false)
                  setactive8C(false)
                  setactive8D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Toutes ces options</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(35)
                    setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active8A || active8B || active8C || active8D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active9A || active9B || active9C || active9D) setProgress(45)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  } */
  
  const Question9 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Quel est le principal problème que vous rencontrez avec Mobile Money ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active9A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active9A) {
                  setactive9A(true)
                  setactive9B(false)
                  setactive9C(false)
                  setactive9D(false)
                  setactive9E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Frais élevés</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active9B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active9B) {
                  setactive9A(false)
                  setactive9B(true)
                  setactive9C(false)
                  setactive9D(false)
                  setactive9E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Transactions échouées</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active9C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active9C) {
                  setactive9A(false)
                  setactive9B(false)
                  setactive9C(true)
                  setactive9D(false)
                  setactive9E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Mauvais service client</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active9D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active9D) {
                  setactive9A(false)
                  setactive9B(false)
                  setactive9C(false)
                  setactive9D(true)
                  setactive9E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Limitations du service</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active9E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active9E) {
                  setactive9A(false)
                  setactive9B(false)
                  setactive9C(false)
                  setactive9D(false)
                  setactive9E(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">E. Aucun problème</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(40)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active9A || active9B || active9C || active9D || active9E)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active10A || active10B || active10C || active10D) setProgress(50)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question10 = () => {
    return (
      <>
        <Heading w="100%" fontSize={'xl'} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Quel type de téléphone utilisez-vous principalement ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active10A ? "solid" : "outline"} onClick={() => {
                if (!active10A) {
                  setactive10A(true)
                  setactive10B(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Smartphone (téléphone connecté à Internet)</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active10B ? "solid" : "outline"} onClick={() => {
                if (!active10B) {
                  setactive10A(false)
                  setactive10B(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Téléphone simple (pas d’accès Internet)</Text>
              </Center>
            </Button>            
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                bg={'gray'}
                rounded={'full'}
                colorScheme="gray"
                onClick={() => {
                  setStep(step - 1)
                  //setProgress(45)
                  setProgress(Math.round((progress - 3.33) * 100) / 100)
                }}
              >
                Retour
              </Button>
              <Button
                bg={'#FFD700'}
                rounded={'full'}
                colorScheme="yellow"
                isDisabled={!(active10A || active10B)}
                onClick={() => {
                  setStep(step + 1)
                  //if (active11A || active11B || active11C || active11D) setProgress(55)
                  setProgress(Math.round((progress + 3.33) * 100) / 100)
                }}
              >
                Suivant
              </Button>
            </ButtonGroup>
        </Box>
      </>
    )
  }
  
  const Question11 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          À quelle fréquence avez-vous accès à Internet mobile ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active11A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active11A) {
                  setactive11A(true)
                  setactive11B(false)
                  setactive11C(false)
                  setactive11D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Tous les jours</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active11B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active11B) {
                  setactive11A(false)
                  setactive11B(true)
                  setactive11C(false)
                  setactive11D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Quelques fois par semaine</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active11C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active11C) {
                  setactive11A(false)
                  setactive11B(false)
                  setactive11C(true)
                  setactive11D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Rarement</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active11D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active11D) {
                  setactive11A(false)
                  setactive11B(false)
                  setactive11C(false)
                  setactive11D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Jamais</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(50)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active11A || active11B || active11C || active11D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active12A || active12B || active12C || active12D) setProgress(60)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  /* const Question12 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Si Cicabank rendait ces transactions plus rapides et moins coûteuses, utiliseriez-vous ses services ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active12A) {
                  setactive12A(true)
                  setactive12B(false)
                  setactive12C(false)
                  setactive12D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, absolument</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active12B) {
                  setactive12A(false)
                  setactive12B(true)
                  setactive12C(false)
                  setactive12D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, mais seulement si les frais sont très bas</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active12C) {
                  setactive12A(false)
                  setactive12B(false)
                  setactive12C(true)
                  setactive12D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Peut-être, cela dépend de la simplicité d’utilisation</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active12D) {
                  setactive12A(false)
                  setactive12B(false)
                  setactive12C(false)
                  setactive12D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Non, je préfère mes solutions actuelles</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(55)
                    setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active12A || active12B || active12C || active12D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active13A || active13B || active13C || active13D) setProgress(65)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question13 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Qu’est-ce qui vous rassurerait le plus avec Cicabank ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active13A) {
                  setactive13A(true)
                  setactive13B(false)
                  setactive13C(false)
                  setactive13D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Mes données personnelles sont protégées</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active13B) {
                  setactive13A(false)
                  setactive13B(true)
                  setactive13C(false)
                  setactive13D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Je reçois une alerte pour chaque transaction</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active13C) {
                  setactive13A(false)
                  setactive13B(false)
                  setactive13C(true)
                  setactive13D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Je peux utiliser un code ou mon empreinte digitale pour sécuriser mon compte</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active13D) {
                  setactive13A(false)
                  setactive13B(false)
                  setactive13C(false)
                  setactive13D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Tout est clair et transparent</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(60)
                    setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active13A || active13B || active13C || active13D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active14A || active14B || active14C || active14D) setProgress(70)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  } */
  
  const Question14 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Avez-vous un compte bancaire aujourd'hui ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active14A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active14A) {
                  setactive14A(true)
                  setactive14B(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active14B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active14B) {
                  setactive14A(false)
                  setactive14B(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Non</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(65)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active14A || active14B)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active15A || active15B || active15C || active15D) setProgress(75)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  /* const Question15 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Pensez-vous que Cicabank peut simplifier vos paiements quotidiens et internationaux ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active15A) {
                  setactive15A(true)
                  setactive15B(false)
                  setactive15C(false)
                  setactive15D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, beaucoup</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active15B) {
                  setactive15A(false)
                  setactive15B(true)
                  setactive15C(false)
                  setactive15D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, un peu</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active15C) {
                  setactive15A(false)
                  setactive15B(false)
                  setactive15C(true)
                  setactive15D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Peut-être, cela dépend des services proposés</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active15D) {
                  setactive15A(false)
                  setactive15B(false)
                  setactive15C(false)
                  setactive15D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Non, je ne pense pas</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(70)
                    setProgress(progress - 5)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active15A || active15B || active15C || active15D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active16A || active16B || active16C || active16D) setProgress(80)
                    setProgress(progress + 5)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  } */
  
  const Question16 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          À quelle fréquence l’utilisez-vous ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active16A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active16A) {
                  setactive16A(true)
                  setactive16B(false)
                  setactive16C(false)
                  setactive16D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Plusieurs fois par semaine</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active16B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active16B) {
                  setactive16A(false)
                  setactive16B(true)
                  setactive16C(false)
                  setactive16D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Une fois par semaine</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active16C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active16C) {
                  setactive16A(false)
                  setactive16B(false)
                  setactive16C(true)
                  setactive16D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Moins d'une fois par mois</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active16D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active16D) {
                  setactive16A(false)
                  setactive16B(false)
                  setactive16C(false)
                  setactive16D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Jamais</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(75)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active16A || active16B || active16C || active16D)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active17A || active17B || active17C || active17D) setProgress(85)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question17 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Comment épargnez-vous votre argent ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active17A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active17A) {
                  setactive17A(true)
                  setactive17B(false)
                  setactive17C(false)
                  setactive17D(false)
                  setactive17E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Espèces cachées à la maison</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active17B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active17B) {
                  setactive17A(false)
                  setactive17B(true)
                  setactive17C(false)
                  setactive17D(false)
                  setactive17E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Compte d’épargne bancaire</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active17C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active17C) {
                  setactive17A(false)
                  setactive17B(false)
                  setactive17C(true)
                  setactive17D(false)
                  setactive17E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Mobile Money</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active17D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active17D) {
                  setactive17A(false)
                  setactive17B(false)
                  setactive17C(false)
                  setactive17D(true)
                  setactive17E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Groupe d’épargne (tontine)</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active17E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active17E) {
                  setactive17A(false)
                  setactive17B(false)
                  setactive17C(false)
                  setactive17D(false)
                  setactive17E(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">E. Je n’épargne pas</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(80)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active17A || active17B || active17C || active17D || active17E)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active18A || active18B || active18C || active18D) setProgress(90)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question18 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
        Seriez-vous intéressé par un service d’épargne automatique via votre téléphone ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active18A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active18A) {
                  setactive18A(true)
                  setactive18B(false)
                  setactive18C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, certainement</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active18B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active18B) {
                  setactive18A(false)
                  setactive18B(true)
                  setactive18C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Peut-être</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active18C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active18C) {
                  setactive18A(false)
                  setactive18B(false)
                  setactive18C(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Non</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(85)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active18A || active18B || active18C)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active19A || active19B || active19C || active19D) setProgress(95)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question19 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
          Seriez-vous intéressé par une tontine digitale et sécurisée ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active19A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active19A) {
                  setactive19A(true)
                  setactive19B(false)
                  setactive19C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active19B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active19B) {
                  setactive19A(false)
                  setactive19B(true)
                  setactive19C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Non</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active19C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active19C) {
                  setactive19A(false)
                  setactive19B(false)
                  setactive19C(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Peut-être</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(90)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active19A || active19B || active19C)}
                  size={buttonSize}
                  onClick={() => {
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }
  
  const Question20 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Avez-vous déjà contracté un prêt ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active20A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active20A) {
                  setactive20A(true)
                  setactive20B(false)
                  setactive20C(false)
                  setactive20D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, auprès d'une banque</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active20B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active20B) {
                  setactive20A(false)
                  setactive20B(true)
                  setactive20C(false)
                  setactive20D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, via Mobile Money</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active20C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active20C) {
                  setactive20A(false)
                  setactive20B(false)
                  setactive20C(true)
                  setactive20D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Oui, auprès d’un proche ou d’une tontine</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active20D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active20D) {
                  setactive20A(false)
                  setactive20B(false)
                  setactive20C(false)
                  setactive20D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Non, jamais</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active20A || active20B || active20C || active20D)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question21 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Si vous pouviez demander un prêt par téléphone, qu'est-ce qui serait le plus important pour vous ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active21A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active21A) {
                  setactive21A(true)
                  setactive21B(false)
                  setactive21C(false)
                  setactive21D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Rapidité d'obtention</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active21B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active21B) {
                  setactive21A(false)
                  setactive21B(true)
                  setactive21C(false)
                  setactive21D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Taux d'intérêt faible</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active21C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active21C) {
                  setactive21A(false)
                  setactive21B(false)
                  setactive21C(true)
                  setactive21D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Pas besoin de garantie</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active21D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active21D) {
                  setactive21A(false)
                  setactive21B(false)
                  setactive21C(false)
                  setactive21D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Flexibilité de remboursement</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active21A || active21B || active21C || active21D)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question23 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Quelle est votre principale inquiétude concernant les services financiers digitaux ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active23A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active23A) {
                  setactive23A(true)
                  setactive23B(false)
                  setactive23C(false)
                  setactive23D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Vol ou perte d’argent</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active23B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active23B) {
                  setactive23A(false)
                  setactive23B(true)
                  setactive23C(false)
                  setactive23D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Vol de données personnelles</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active23C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active23C) {
                  setactive23A(false)
                  setactive23B(false)
                  setactive23C(true)
                  setactive23D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Difficulté d’avoir de l’assistance en cas de problème</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active23D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active23D) {
                  setactive23A(false)
                  setactive23B(false)
                  setactive23C(false)
                  setactive23D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Difficulté d’utilisation</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active23A || active23B || active23C || active23D)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question24 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Quel type de support client préférez-vous ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active24A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active24A) {
                  setactive24A(true)
                  setactive24B(false)
                  setactive24C(false)
                  setactive24D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Chat dans l'application</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active24B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active24B) {
                  setactive24A(false)
                  setactive24B(true)
                  setactive24C(false)
                  setactive24D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Numéro d’appel gratuit</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active24C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active24C) {
                  setactive24A(false)
                  setactive24B(false)
                  setactive24C(true)
                  setactive24D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Assistance par WhatsApp</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active24D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active24D) {
                  setactive24A(false)
                  setactive24B(false)
                  setactive24C(false)
                  setactive24D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Pouvoir se déplacer en agence</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active24A || active24B || active24C || active24D)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question25 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Voir vos transactions en temps réel est-il important pour vous ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active25A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active25A) {
                  setactive25A(true)
                  setactive25B(false)
                  setactive25C(false)
                  setactive25D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Très important</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active25B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active25B) {
                  setactive25A(false)
                  setactive25B(true)
                  setactive25C(false)
                  setactive25D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Important</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active25C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active25C) {
                  setactive25A(false)
                  setactive25B(false)
                  setactive25C(true)
                  setactive25D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Peu important</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active25D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active25D) {
                  setactive25A(false)
                  setactive25B(false)
                  setactive25C(false)
                  setactive25D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Pas important du tout</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active25A || active25B || active25C || active25D)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question26 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Préférez-vous des frais bancaires ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active26A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active26A) {
                  setactive26A(true)
                  setactive26B(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Fixes et transparents, même s’ils sont un peu élevés</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active26B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active26B) {
                  setactive26A(false)
                  setactive26B(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Très bas mais variables selon les opérations</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active26A || active26B)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question27 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Quels services aimeriez-vous retrouver dans une application bancaire ? (choix multiples possibles)
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active27A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active27A) {
                  setactive27A(true)
                }
                else {
                  setactive27A(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Paiement de factures (eau, électricité, Internet)</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active27B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active27B) {
                  setactive27B(true)
                }
                else {
                  setactive27B(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Transfert d’argent international</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active27C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active27C) {
                  setactive27C(true)
                }
                else {
                  setactive27C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Cagnotte collective (ex. mariage, fêtes)</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active27D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active27D) {
                  setactive27D(true)
                }
                else {
                  setactive27D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Achat de crédit téléphonique</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active27E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active27E) {
                  setactive27E(true)
                }
                else {
                  setactive27E(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">E. Assurance santé ou scolaire</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active27F ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active27F) {
                  setactive27F(true)
                }
                else {
                  setactive27F(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">F. Récompenses (programme fidélité)</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active27A || active27B || active27C || active27D|| active27E || active27F)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question28 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Quelle est la priorité la plus importante pour vous dans une banque mobile ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active28A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active28A) {
                  setactive28A(true)
                  setactive28B(false)
                  setactive28C(false)
                  setactive28D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Facilité d’utilisation</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active28B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active28B) {
                  setactive28A(false)
                  setactive28B(true)
                  setactive28C(false)
                  setactive28D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Coûts réduits</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active28C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active28C) {
                  setactive28A(false)
                  setactive28B(false)
                  setactive28C(true)
                  setactive28D(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Rapidité d’exécution</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active28D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active28D) {
                  setactive28A(false)
                  setactive28B(false)
                  setactive28C(false)
                  setactive28D(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">D. Sécurité maximale</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active28A || active28B || active28C || active28D)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question29 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Seriez-vous prêt à recommander un service bancaire digital à votre entourage ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active29A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active29A) {
                  setactive29A(true)
                  setactive29B(false)
                  setactive29C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Oui, sans hésiter</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active29B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active29B) {
                  setactive29A(false)
                  setactive29B(true)
                  setactive29C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Oui, après avoir testé longtemps</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active29C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active29C) {
                  setactive29A(false)
                  setactive29B(false)
                  setactive29C(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Non</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active29A || active29B || active29C)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const Question30 = () => {
    return (
      <>
        <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal" color={'black'}>
          Selon vous, que deviendra l’utilisation du cash dans votre pays ?
        </Heading>
        <Center p={useBreakpointValue({ base: "2", md: "8" })}>
          <Stack spacing={5} align={'center'} maxW={useBreakpointValue({ base: "100%", md: "75%" })} w={'full'}>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active30A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active30A) {
                  setactive30A(true)
                  setactive30B(false)
                  setactive30C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">A. Le cash restera dominant</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active30B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active30B) {
                  setactive30A(false)
                  setactive30B(true)
                  setactive30C(false)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">B. Le cash va diminuer au profit du mobile</Text>
              </Center>
            </Button>
            <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active30C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                if (!active30C) {
                  setactive30A(false)
                  setactive30B(false)
                  setactive30C(true)
                }
              }}>
              <Center>
                <Text whiteSpace="normal" textAlign="center">C. Le cash va presque disparaître</Text>
              </Center>
            </Button>
          </Stack>
        </Center>
        <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  size={buttonSize}
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(95)
                    setProgress(Math.round((progress - 3.33) * 100) / 100)
                  }}
                >
                  Retour
                </Button>
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                  isDisabled={!(active30A || active30B || active30C)}
                  size={buttonSize}
                  onClick={() => {                  
                    //handleSubmit();
                    setStep(step + 1)
                    //if (active20A || active20B || active20C || active20D) setProgress(100)
                    setProgress(Math.round((progress + 3.33) * 100) / 100)
                  }}
                >
                  {/* Terminer */}
                  Suivant
                </Button>
            </ButtonGroup>
          </Box>
      </>
    )
  }

  const maxWValue = useBreakpointValue({ base: "100%", md: "75%" });
  const paddingValue = useBreakpointValue({ base: 2, md: 6 });

  return (
    <>
      <Box 
        borderWidth="1px"
        rounded="lg"
        shadow="2px 2px 6px rgba(0,0,0,0.3)"
        minH={750}
        maxWidth={1000}
        py={6}
        px={paddingValue}
        m="30px auto"
        as="form"
        alignContent={'center'}
        bgColor='gray.100'>
        {step > 1 && step < 32 && (
          <Flex mb="5%" mx="5%" align="center">
            { <Progress hasStripe value={progress} colorScheme="yellow" isAnimated flex="1" />}
            <Text ml={4} color="black">{progress}%</Text>
          </Flex>
        )}
        {
          step === 1 ? 
            < Intro/> : 
              step === 2 ? 
                <>
                  <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                    Comment gérez-vous principalement votre argent ?
                  </Heading>
                  <Center p={paddingValue}>
                    <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                          if (!active1A) {
                            
                            setActive1A(true)
                            setActive1B(false)
                            setActive1C(false)
                            setActive1D(false)
                          }
                        }}>
                        <Center>
                          <Text whiteSpace="normal" textAlign="center">A. En espèces</Text>
                        </Center>
                      </Button>
                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                          if (!active1B) {
                            setActive1A(false)
                            setActive1B(true)
                            setActive1C(false)
                            setActive1D(false)
                          }
                        }}>
                        <Center>
                          <Text whiteSpace="normal" textAlign="center">B. Par Mobile Money</Text>
                        </Center>
                      </Button>
                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                          if (!active1C) {
                            setActive1A(false)
                            setActive1B(false)
                            setActive1C(true)
                            setActive1D(false)
                          }
                        }}>
                        <Center>
                          <Text whiteSpace="normal" textAlign="center">C. Par compte bancaire</Text>
                        </Center>
                      </Button>
                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active1D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                          if (!active1D) {
                            setActive1A(false)
                            setActive1B(false)
                            setActive1C(false)
                            setActive1D(true)
                          }
                        }}>
                        <Center>
                          <Text whiteSpace="normal" textAlign="center">D. Autre</Text>
                        </Center>
                      </Button>
                      {
                        active1D && (
                          <Textarea 
                            value={textAreaValue1}
                            onChange={handleInputChange1}
                            placeholder="Veuillez écrire votre réponse !"
                            focusBorderColor="#FFD700"
                            borderColor={'black'} 
                          />
                        )
                      }            
                    </Stack>
                  </Center>
                  <Box mt={4} align={'center'}>
                    <ButtonGroup mt={4} spacing={10}>
                      <Button
                        bg={'gray'}
                        rounded={'full'}
                        colorScheme="gray"
                        size={buttonSize}
                        onClick={() => {
                          setStep(step - 1)
                          //setProgress(45)
                          setProgress(Math.round((progress - 3.33) * 100) / 100)
                        }}
                      >
                        Retour
                      </Button>
                      <Button
                        bg={'#FFD700'}
                        rounded={'full'}
                        colorScheme="yellow"
                        isDisabled={!(active1A || active1B || active1C || (active1D && textAreaValue1 !== ''))}
                        size={buttonSize}
                        onClick={() => {
                          setStep(step + 1)
                          //if (active11A || active11B || active11C || active11D) setProgress(55)
                          setProgress(Math.round((progress + 3.33) * 100) / 100)
                        }}
                      >
                        Suivant
                      </Button>
                    </ButtonGroup>
                  </Box>
                </> : 
                  step === 3 ? 
                    < Question2/> : 
                      step === 4 ? 
                        <>
                          <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                            Quelle est votre principale méthode pour payer vos achats ?
                          </Heading>
                          <Center p={paddingValue}>
                            <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                  if (!active3A) {                                   
                                    setActive3A(true)
                                    setActive3B(false)
                                    setActive3C(false)
                                    setActive3D(false)
                                    setActive3E(false)
                                  }
                                }}>
                                <Center>
                                  <Text whiteSpace="normal" textAlign="center">A. Espèces</Text>
                                </Center>
                              </Button>
                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                  if (!active3B) {
                                    setActive3A(false)
                                    setActive3B(true)
                                    setActive3C(false)
                                    setActive3D(false)
                                    setActive3E(false)
                                  }
                                }}>
                                <Center>
                                  <Text whiteSpace="normal" textAlign="center">B. Mobile Money</Text>
                                </Center>
                              </Button>
                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                  if (!active3C) {
                                    setActive3A(false)
                                    setActive3B(false)
                                    setActive3C(true)
                                    setActive3D(false)
                                    setActive3E(false)
                                  }
                                }}>
                                <Center>
                                  <Text whiteSpace="normal" textAlign="center">C. Carte bancaire</Text>
                                </Center>
                              </Button>
                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                  if (!active3D) {
                                    setActive3A(false)
                                    setActive3B(false)
                                    setActive3C(false)
                                    setActive3D(true)
                                    setActive3E(false)
                                  }
                                }}>
                                <Center>
                                  <Text whiteSpace="normal" textAlign="center">D. Application bancaire mobile</Text>
                                </Center>
                              </Button>
                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active3E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                  if (!active3E) {
                                    setActive3A(false)
                                    setActive3B(false)
                                    setActive3C(false)
                                    setActive3D(false)
                                    setActive3E(true)
                                  }
                                }}>
                                <Center>
                                  <Text whiteSpace="normal" textAlign="center">E. Autre</Text>
                                </Center>
                              </Button>
                              {
                                active3E && (
                                  <Textarea 
                                    value={textAreaValue3}
                                    onChange={handleInputChange3}
                                    placeholder="Veuillez écrire votre réponse !"
                                    focusBorderColor="#FFD700"
                                    borderColor={'black'} 
                                  />
                                )
                              }            
                            </Stack>
                          </Center>
                          <Box mt={4} align={'center'}>
                            <ButtonGroup mt={4} spacing={10}>
                              <Button
                                bg={'gray'}
                                rounded={'full'}
                                colorScheme="gray"
                                size={buttonSize}
                                onClick={() => {
                                  setStep(step - 1)
                                  //setProgress(45)
                                  setProgress(Math.round((progress - 3.33) * 100) / 100)
                                }}
                              >
                                Retour
                              </Button>
                              <Button
                                bg={'#FFD700'}
                                rounded={'full'}
                                colorScheme="yellow"
                                isDisabled={!(active3A || active3B || active3C || active3D || (active3E && textAreaValue3 !== ''))}
                                size={buttonSize}
                                onClick={() => {
                                  setStep(step + 1)
                                  //if (active11A || active11B || active11C || active11D) setProgress(55)
                                  setProgress(Math.round((progress + 3.33) * 100) / 100)
                                }}
                              >
                                Suivant
                              </Button>
                            </ButtonGroup>
                          </Box>
                        </> : 
                          step === 5 ? 
                            <>
                              <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                Où utilisez-vous principalement l'argent liquide ?
                              </Heading>
                              <Center p={paddingValue}>
                                <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                  <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                      if (!active4A) {                                   
                                        setActive4A(true)
                                        setActive4B(false)
                                        setActive4C(false)
                                        setActive4D(false)
                                        setActive4E(false)
                                      }
                                    }}>
                                    <Center>
                                      <Text whiteSpace="normal" textAlign="center">A. Marché</Text>
                                    </Center>
                                  </Button>
                                  <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                      if (!active4B) {
                                        setActive4A(false)
                                        setActive4B(true)
                                        setActive4C(false)
                                        setActive4D(false)
                                        setActive4E(false)
                                      }
                                    }}>
                                    <Center>
                                      <Text whiteSpace="normal" textAlign="center">B. Magasins (Boutiques)</Text>
                                    </Center>
                                  </Button>
                                  <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                      if (!active4C) {
                                        setActive4A(false)
                                        setActive4B(false)
                                        setActive4C(true)
                                        setActive4D(false)
                                        setActive4E(false)
                                      }
                                    }}>
                                    <Center>
                                      <Text whiteSpace="normal" textAlign="center">C. Transport</Text>
                                    </Center>
                                  </Button>
                                  <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                      if (!active4D) {
                                        setActive4A(false)
                                        setActive4B(false)
                                        setActive4C(false)
                                        setActive4D(true)
                                        setActive4E(false)
                                      }
                                    }}>
                                    <Center>
                                      <Text whiteSpace="normal" textAlign="center">D. Paiement de services (eau, électricité, etc.)</Text>
                                    </Center>
                                  </Button>
                                  <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active4E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                      if (!active4E) {
                                        setActive4A(false)
                                        setActive4B(false)
                                        setActive4C(false)
                                        setActive4D(false)
                                        setActive4E(true)
                                      }
                                    }}>
                                    <Center>
                                      <Text whiteSpace="normal" textAlign="center">E. Autre</Text>
                                    </Center>
                                  </Button>
                                  {
                                    active4E && (
                                      <Textarea 
                                        value={textAreaValue4}
                                        onChange={handleInputChange4}
                                        placeholder="Veuillez écrire votre réponse !"
                                        focusBorderColor="#FFD700"
                                        borderColor={'black'} 
                                      />
                                    )
                                  }            
                                </Stack>
                              </Center>
                              <Box mt={4} align={'center'}>
                                <ButtonGroup mt={4} spacing={10}>
                                  <Button
                                    bg={'gray'}
                                    rounded={'full'}
                                    colorScheme="gray"
                                    size={buttonSize}
                                    onClick={() => {
                                      setStep(step - 1)
                                      //setProgress(45)
                                      setProgress(Math.round((progress - 3.33) * 100) / 100)
                                    }}
                                  >
                                    Retour
                                  </Button>
                                  <Button
                                    bg={'#FFD700'}
                                    rounded={'full'}
                                    colorScheme="yellow"
                                    isDisabled={!(active4A || active4B || active4C || active4D || (active4E && textAreaValue4 !== ''))}
                                    size={buttonSize}
                                    onClick={() => {
                                      setStep(step + 1)
                                      //if (active11A || active11B || active11C || active11D) setProgress(55)
                                      setProgress(Math.round((progress + 3.33) * 100) / 100)
                                    }}
                                  >
                                    Suivant
                                  </Button>
                                </ButtonGroup>
                              </Box>
                            </> : 
                            step === 6 ? 
                              < Question5/> : 
                              step === 7 ? 
                                < Question6/> : 
                                  step === 8 ? 
                                    <>
                                      <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                        Quel service Mobile Money utilisez-vous le plus souvent ?
                                      </Heading>
                                      <Center p={paddingValue}>
                                        <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active7A) {                                   
                                                setactive7A(true)
                                                setactive7B(false)
                                                setactive7C(false)
                                                setactive7D(false)
                                                setactive7E(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">A. Orange Money</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active7B) {
                                                setactive7A(false)
                                                setactive7B(true)
                                                setactive7C(false)
                                                setactive7D(false)
                                                setactive7E(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">B. MTN Mobile Money</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active7C) {
                                                setactive7A(false)
                                                setactive7B(false)
                                                setactive7C(true)
                                                setactive7D(false)
                                                setactive7E(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">C. Moov Money</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active7D) {
                                                setactive7A(false)
                                                setactive7B(false)
                                                setactive7C(false)
                                                setactive7D(true)
                                                setactive7E(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">D. Wave</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active7E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active7E) {
                                                setactive7A(false)
                                                setactive7B(false)
                                                setactive7C(false)
                                                setactive7D(false)
                                                setactive7E(true)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">E. Autre</Text>
                                            </Center>
                                          </Button>
                                          {
                                            active7E && (
                                              <Textarea 
                                                value={textAreaValue7}
                                                onChange={handleInputChange7}
                                                placeholder="Veuillez écrire votre réponse !"
                                                focusBorderColor="#FFD700"
                                                borderColor={'black'} 
                                              />
                                            )
                                          }            
                                        </Stack>
                                      </Center>
                                      <Box mt={4} align={'center'}>
                                        <ButtonGroup mt={4} spacing={10}>
                                          <Button
                                            bg={'gray'}
                                            rounded={'full'}
                                            colorScheme="gray"
                                            size={buttonSize}
                                            onClick={() => {
                                              setStep(step - 1)
                                              //setProgress(45)
                                              setProgress(Math.round((progress - 3.33) * 100) / 100)
                                            }}
                                          >
                                            Retour
                                          </Button>
                                          <Button
                                            bg={'#FFD700'}
                                            rounded={'full'}
                                            colorScheme="yellow"
                                            isDisabled={!(active7A || active7B || active7C || active7D || (active7E && textAreaValue7 !== ''))}
                                            size={buttonSize}
                                            onClick={() => {
                                              setStep(step + 1)
                                              //if (active11A || active11B || active11C || active11D) setProgress(55)
                                              setProgress(Math.round((progress + 3.33) * 100) / 100)
                                            }}
                                          >
                                            Suivant
                                          </Button>
                                        </ButtonGroup>
                                      </Box>
                                    </> : 
                                  step === 9 ? 
                                    <>
                                      <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                        Pourquoi utilisez-vous principalement Mobile Money ? (choix multiples possibles)
                                      </Heading>
                                      <Center p={paddingValue}>
                                        <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active8A) {                                   
                                                setactive8A(true)
                                                /* setactive8B(false)
                                                setactive8C(false)
                                                setactive8D(false)
                                                setactive8E(false)
                                                setactive8F(false) */
                                              }
                                              else {
                                                setactive8A(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">A. Envoyer de l’argent</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active8B) {
                                                //setactive8A(false)
                                                setactive8B(true)
                                                /* setactive8C(false)
                                                setactive8D(false)
                                                setactive8E(false)
                                                setactive8F(false) */
                                              }
                                              else {
                                                setactive8B(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">B. Recevoir de l’argent</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active8C) {
                                                /* setactive8A(false)
                                                setactive8B(false) */
                                                setactive8C(true)
                                                /* setactive8D(false)
                                                setactive8E(false)
                                                setactive8F(false) */
                                              }
                                              else {
                                                setactive8C(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">C. Payer des factures</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active8D) {
                                                /* setactive8A(false)
                                                setactive8B(false)
                                                setactive8C(false) */
                                                setactive8D(true)
                                                /* setactive8E(false)
                                                setactive8F(false) */
                                              }
                                              else {
                                                setactive8D(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">D. Acheter du crédit téléphonique</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active8E) {
                                                /* setactive8A(false)
                                                setactive8B(false)
                                                setactive8C(false)
                                                setactive8D(false) */
                                                setactive8E(true)
                                                //setactive8F(false)
                                              }
                                              else {
                                                setactive8E(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">E. Épargner</Text>
                                            </Center>
                                          </Button>
                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active8F ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                              if (!active8F) {
                                                /* setactive8A(false)
                                                setactive8B(false)
                                                setactive8C(false)
                                                setactive8D(false)
                                                setactive8E(false) */
                                                setactive8F(true)
                                              }
                                              else {
                                                setactive8F(false)
                                              }
                                            }}>
                                            <Center>
                                              <Text whiteSpace="normal" textAlign="center">F. Autre</Text>
                                            </Center>
                                          </Button>
                                          {
                                            active8F && (
                                              <Textarea 
                                                value={textAreaValue8}
                                                onChange={handleInputChange8}
                                                placeholder="Veuillez écrire votre réponse !"
                                                focusBorderColor="#FFD700"
                                                borderColor={'black'} 
                                              />
                                            )
                                          }            
                                        </Stack>
                                      </Center>
                                      <Box mt={4} align={'center'}>
                                        <ButtonGroup mt={4} spacing={10}>
                                          <Button
                                            bg={'gray'}
                                            rounded={'full'}
                                            colorScheme="gray"
                                            size={buttonSize}
                                            onClick={() => {
                                              setStep(step - 1)
                                              //setProgress(45)
                                              setProgress(Math.round((progress - 3.33) * 100) / 100)
                                            }}
                                          >
                                            Retour
                                          </Button>
                                          <Button
                                            bg={'#FFD700'}
                                            rounded={'full'}
                                            colorScheme="yellow"
                                            isDisabled={!(active8A || active8B || active8C || active8D || active8E || (active8F && textAreaValue8 !== ''))}
                                            size={buttonSize}
                                            onClick={() => {
                                              setStep(step + 1)
                                              //if (active11A || active11B || active11C || active11D) setProgress(55)
                                              setProgress(Math.round((progress + 3.33) * 100) / 100)
                                            }}
                                          >
                                            Suivant
                                          </Button>
                                        </ButtonGroup>
                                      </Box>
                                    </> : 
                                      step === 10 ? 
                                        < Question9/> : 
                                          step === 11 ? 
                                            < Question10/>: 
                                              step === 12 ? 
                                                < Question11/> : 
                                                  step === 13 ? 
                                                    <>
                                                      <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                                        Si vous perdez votre connexion Internet, comment préférez-vous accéder à votre compte ? <br/> *(Définition simple : USSD = menus simples accessibles en tapant des codes comme 123# ; SMS = messages courts envoyés via téléphone)
                                                      </Heading>
                                                      <Center p={paddingValue}>
                                                        <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                              if (!active12A) {                    
                                                                setactive12A(true)
                                                                setactive12B(false)
                                                                setactive12C(false)
                                                                setactive12D(false)
                                                              }
                                                            }}>
                                                            <Center>
                                                              <Text whiteSpace="normal" textAlign="center">A. Par code USSD (*123#)</Text>
                                                            </Center>
                                                          </Button>
                                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                              if (!active12B) {
                                                                setactive12A(false)
                                                                setactive12B(true)
                                                                setactive12C(false)
                                                                setactive12D(false)
                                                              }
                                                            }}>
                                                            <Center>
                                                              <Text whiteSpace="normal" textAlign="center">B. Par SMS</Text>
                                                            </Center>
                                                          </Button>
                                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                              if (!active12C) {
                                                                setactive12A(false)
                                                                setactive12B(false)
                                                                setactive12C(true)
                                                                setactive12D(false)
                                                              }
                                                            }}>
                                                            <Center>
                                                              <Text whiteSpace="normal" textAlign="center">C. Par appel téléphonique</Text>
                                                            </Center>
                                                          </Button>
                                                          <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active12D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                              if (!active12D) {
                                                                setactive12A(false)
                                                                setactive12B(false)
                                                                setactive12C(false)
                                                                setactive12D(true)
                                                              }
                                                            }}>
                                                            <Center>
                                                              <Text whiteSpace="normal" textAlign="center">D. Autre</Text>
                                                            </Center>
                                                          </Button>
                                                          {
                                                            active12D && (
                                                              <Textarea 
                                                                value={textAreaValue12}
                                                                onChange={handleInputChange12}
                                                                placeholder="Veuillez écrire votre réponse !"
                                                                focusBorderColor="#FFD700"
                                                                borderColor={'black'} 
                                                              />
                                                            )
                                                          }            
                                                        </Stack>
                                                      </Center>
                                                      <Box mt={4} align={'center'}>
                                                        <ButtonGroup mt={4} spacing={10}>
                                                          <Button
                                                            bg={'gray'}
                                                            rounded={'full'}
                                                            colorScheme="gray"
                                                            size={buttonSize}
                                                            onClick={() => {
                                                              setStep(step - 1)
                                                              //setProgress(45)
                                                              setProgress(Math.round((progress - 3.33) * 100) / 100)
                                                            }}
                                                          >
                                                            Retour
                                                          </Button>
                                                          <Button
                                                            bg={'#FFD700'}
                                                            rounded={'full'}
                                                            colorScheme="yellow"
                                                            isDisabled={!(active12A || active12B || active12C || (active12D && textAreaValue12 !== ''))}
                                                            size={buttonSize}
                                                            onClick={() => {
                                                              setStep(step + 1)
                                                              //if (active11A || active11B || active11C || active11D) setProgress(55)
                                                              setProgress(Math.round((progress + 3.33) * 100) / 100)
                                                            }}
                                                          >
                                                            Suivant
                                                          </Button>
                                                        </ButtonGroup>
                                                      </Box>
                                                    </> : 
                                                      step === 14 ? 
                                                        <>
                                                          <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                                            Quel fournisseur Internet utilisez-vous principalement ?
                                                          </Heading>
                                                          <Center p={paddingValue}>
                                                            <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                  if (!active13A) {                    
                                                                    setactive13A(true)
                                                                    setactive13B(false)
                                                                    setactive13C(false)
                                                                    setactive13D(false)
                                                                  }
                                                                }}>
                                                                <Center>
                                                                  <Text whiteSpace="normal" textAlign="center">A. Orange</Text>
                                                                </Center>
                                                              </Button>
                                                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                  if (!active13B) {
                                                                    setactive13A(false)
                                                                    setactive13B(true)
                                                                    setactive13C(false)
                                                                    setactive13D(false)
                                                                  }
                                                                }}>
                                                                <Center>
                                                                  <Text whiteSpace="normal" textAlign="center">B. MTN</Text>
                                                                </Center>
                                                              </Button>
                                                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                  if (!active13C) {
                                                                    setactive13A(false)
                                                                    setactive13B(false)
                                                                    setactive13C(true)
                                                                    setactive13D(false)
                                                                  }
                                                                }}>
                                                                <Center>
                                                                  <Text whiteSpace="normal" textAlign="center">C. Moov</Text>
                                                                </Center>
                                                              </Button>
                                                              <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active13D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                  if (!active13D) {
                                                                    setactive13A(false)
                                                                    setactive13B(false)
                                                                    setactive13C(false)
                                                                    setactive13D(true)
                                                                  }
                                                                }}>
                                                                <Center>
                                                                  <Text whiteSpace="normal" textAlign="center">D. Autre</Text>
                                                                </Center>
                                                              </Button>
                                                              {
                                                                active13D && (
                                                                  <Textarea 
                                                                    value={textAreaValue13}
                                                                    onChange={handleInputChange13}
                                                                    placeholder="Veuillez écrire votre réponse !"
                                                                    focusBorderColor="#FFD700"
                                                                    borderColor={'black'} 
                                                                  />
                                                                )
                                                              }            
                                                            </Stack>
                                                          </Center>
                                                          <Box mt={4} align={'center'}>
                                                            <ButtonGroup mt={4} spacing={10}>
                                                              <Button
                                                                bg={'gray'}
                                                                rounded={'full'}
                                                                colorScheme="gray"
                                                                size={buttonSize}
                                                                onClick={() => {
                                                                  setStep(step - 1)
                                                                  //setProgress(45)
                                                                  setProgress(Math.round((progress - 3.33) * 100) / 100)
                                                                }}
                                                              >
                                                                Retour
                                                              </Button>
                                                              <Button
                                                                bg={'#FFD700'}
                                                                rounded={'full'}
                                                                colorScheme="yellow"
                                                                isDisabled={!(active13A || active13B || active13C || (active13D && textAreaValue13 !== ''))}
                                                                size={buttonSize}
                                                                onClick={() => {
                                                                  setStep(step + 1)
                                                                  //if (active11A || active11B || active11C || active11D) setProgress(55)
                                                                  setProgress(Math.round((progress + 3.33) * 100) / 100)
                                                                }}
                                                              >
                                                                Suivant
                                                              </Button>
                                                            </ButtonGroup>
                                                          </Box>
                                                        </> : 
                                                          step === 15 ? 
                                                            < Question14/> : 
                                                              (step === 16 && active14B) ? 
                                                                <>
                                                                <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                                                  Pourquoi n'avez-vous pas de compte bancaire ?
                                                                </Heading>
                                                                <Center p={paddingValue}>
                                                                  <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                                                    <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                        if (!active15A) {                                   
                                                                          setactive15A(true)
                                                                          setactive15B(false)
                                                                          setactive15C(false)
                                                                          setactive15D(false)
                                                                          setactive15E(false)
                                                                        }
                                                                      }}>
                                                                      <Center>
                                                                        <Text whiteSpace="normal" textAlign="center">A. Frais trop élevés</Text>
                                                                      </Center>
                                                                    </Button>
                                                                    <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                        if (!active15B) {
                                                                          setactive15A(false)
                                                                          setactive15B(true)
                                                                          setactive15C(false)
                                                                          setactive15D(false)
                                                                          setactive15E(false)
                                                                        }
                                                                      }}>
                                                                      <Center>
                                                                        <Text whiteSpace="normal" textAlign="center">B. Manque de confiance</Text>
                                                                      </Center>
                                                                    </Button>
                                                                    <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                        if (!active15C) {
                                                                          setactive15A(false)
                                                                          setactive15B(false)
                                                                          setactive15C(true)
                                                                          setactive15D(false)
                                                                          setactive15E(false)
                                                                        }
                                                                      }}>
                                                                      <Center>
                                                                        <Text whiteSpace="normal" textAlign="center">C. Démarches compliquées</Text>
                                                                      </Center>
                                                                    </Button>
                                                                    <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                        if (!active15D) {
                                                                          setactive15A(false)
                                                                          setactive15B(false)
                                                                          setactive15C(false)
                                                                          setactive15D(true)
                                                                          setactive15E(false)
                                                                        }
                                                                      }}>
                                                                      <Center>
                                                                        <Text whiteSpace="normal" textAlign="center">D. Pas besoin</Text>
                                                                      </Center>
                                                                    </Button>
                                                                    <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active15E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                        if (!active15E) {
                                                                          setactive15A(false)
                                                                          setactive15B(false)
                                                                          setactive15C(false)
                                                                          setactive15D(false)
                                                                          setactive15E(true)
                                                                        }
                                                                      }}>
                                                                      <Center>
                                                                        <Text whiteSpace="normal" textAlign="center">E. Autre</Text>
                                                                      </Center>
                                                                    </Button>
                                                                    {
                                                                      active15E && (
                                                                        <Textarea 
                                                                          value={textAreaValue15}
                                                                          onChange={handleInputChange15}
                                                                          placeholder="Veuillez écrire votre réponse !"
                                                                          focusBorderColor="#FFD700"
                                                                          borderColor={'black'} 
                                                                        />
                                                                      )
                                                                    }            
                                                                  </Stack>
                                                                </Center>
                                                                <Box mt={4} align={'center'}>
                                                                  <ButtonGroup mt={4} spacing={10}>
                                                                    <Button
                                                                      bg={'gray'}
                                                                      rounded={'full'}
                                                                      colorScheme="gray"
                                                                      size={buttonSize}
                                                                      onClick={() => {
                                                                        setStep(step - 1)
                                                                        //setProgress(45)
                                                                        setProgress(Math.round((progress - 3.33) * 100) / 100)
                                                                      }}
                                                                    >
                                                                      Retour
                                                                    </Button>
                                                                    <Button
                                                                      bg={'#FFD700'}
                                                                      rounded={'full'}
                                                                      colorScheme="yellow"
                                                                      isDisabled={!(active15A || active15B || active15C || active15D || (active15E && textAreaValue15 !== ''))}
                                                                      size={buttonSize}
                                                                      onClick={() => {
                                                                        setStep(step + 1)
                                                                        //if (active11A || active11B || active11C || active11D) setProgress(55)
                                                                        setProgress(Math.round((progress + 3.33) * 100) / 100)
                                                                      }}
                                                                    >
                                                                      Suivant
                                                                    </Button>
                                                                  </ButtonGroup>
                                                                </Box>
                                                                </> : 
                                                                  (step === 16 && active14A) ? 
                                                                    < Question16/> : 
                                                                      step === 17 ? 
                                                                          < Question17/> : 
                                                                            step === 18 ? 
                                                                                < Question18/> : 
                                                                                  step === 19 ? 
                                                                                    < Question19/> :
                                                                                      step === 20 ?
                                                                                        < Question20/> :
                                                                                          step === 21 ?
                                                                                            <Question21/> :
                                                                                              step === 22 ?
                                                                                                <>
                                                                                                  <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                                                                                    Quel type de prêt vous intéresserait le plus ?
                                                                                                  </Heading>
                                                                                                  <Center p={paddingValue}>
                                                                                                    <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                                                                                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active22A ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                                                          if (!active22A) {                                   
                                                                                                            setactive22A(true)
                                                                                                            setactive22B(false)
                                                                                                            setactive22C(false)
                                                                                                            setactive22D(false)
                                                                                                            setactive22E(false)
                                                                                                          }
                                                                                                        }}>
                                                                                                        <Center>
                                                                                                          <Text whiteSpace="normal" textAlign="center">A. Petit prêt d’urgence</Text>
                                                                                                        </Center>
                                                                                                      </Button>
                                                                                                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active22B ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                                                          if (!active22B) {
                                                                                                            setactive22A(false)
                                                                                                            setactive22B(true)
                                                                                                            setactive22C(false)
                                                                                                            setactive22D(false)
                                                                                                            setactive22E(false)
                                                                                                          }
                                                                                                        }}>
                                                                                                        <Center>
                                                                                                          <Text whiteSpace="normal" textAlign="center">B. Prêt pour lancer ou développer un projet</Text>
                                                                                                        </Center>
                                                                                                      </Button>
                                                                                                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active22C ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                                                          if (!active22C) {
                                                                                                            setactive22A(false)
                                                                                                            setactive22B(false)
                                                                                                            setactive22C(true)
                                                                                                            setactive22D(false)
                                                                                                            setactive22E(false)
                                                                                                          }
                                                                                                        }}>
                                                                                                        <Center>
                                                                                                          <Text whiteSpace="normal" textAlign="center">C. Prêt pour frais scolaires ou santé</Text>
                                                                                                        </Center>
                                                                                                      </Button>
                                                                                                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active22D ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                                                          if (!active22D) {
                                                                                                            setactive22A(false)
                                                                                                            setactive22B(false)
                                                                                                            setactive22C(false)
                                                                                                            setactive22D(true)
                                                                                                            setactive22E(false)
                                                                                                          }
                                                                                                        }}>
                                                                                                        <Center>
                                                                                                          <Text whiteSpace="normal" textAlign="center">D. Prêt immobilier</Text>
                                                                                                        </Center>
                                                                                                      </Button>
                                                                                                      <Button w={'full'} height="auto" minHeight="10" colorScheme={'yellow'} variant={active22E ? "solid" : "outline"} size={buttonSize} onClick={() => {
                                                                                                          if (!active22E) {
                                                                                                            setactive22A(false)
                                                                                                            setactive22B(false)
                                                                                                            setactive22C(false)
                                                                                                            setactive22D(false)
                                                                                                            setactive22E(true)
                                                                                                          }
                                                                                                        }}>
                                                                                                        <Center>
                                                                                                          <Text whiteSpace="normal" textAlign="center">E. Autre</Text>
                                                                                                        </Center>
                                                                                                      </Button>
                                                                                                      {
                                                                                                        active22E && (
                                                                                                          <Textarea 
                                                                                                            value={textAreaValue22}
                                                                                                            onChange={handleInputChange22}
                                                                                                            placeholder="Veuillez écrire votre réponse !"
                                                                                                            focusBorderColor="#FFD700"
                                                                                                            borderColor={'black'} 
                                                                                                          />
                                                                                                        )
                                                                                                      }            
                                                                                                    </Stack>
                                                                                                  </Center>
                                                                                                  <Box mt={4} align={'center'}>
                                                                                                    <ButtonGroup mt={4} spacing={10}>
                                                                                                      <Button
                                                                                                        bg={'gray'}
                                                                                                        rounded={'full'}
                                                                                                        colorScheme="gray"
                                                                                                        size={buttonSize}
                                                                                                        onClick={() => {
                                                                                                          setStep(step - 1)
                                                                                                          //setProgress(45)
                                                                                                          setProgress(Math.round((progress - 3.33) * 100) / 100)
                                                                                                        }}
                                                                                                      >
                                                                                                        Retour
                                                                                                      </Button>
                                                                                                      <Button
                                                                                                        bg={'#FFD700'}
                                                                                                        rounded={'full'}
                                                                                                        colorScheme="yellow"
                                                                                                        isDisabled={!(active22A || active22B || active22C || active22D || (active22E && textAreaValue22 !== ''))}
                                                                                                        size={buttonSize}
                                                                                                        onClick={() => {
                                                                                                          setStep(step + 1)
                                                                                                          //if (active11A || active11B || active11C || active11D) setProgress(55)
                                                                                                          setProgress(Math.round((progress + 3.33) * 100) / 100)
                                                                                                        }}
                                                                                                      >
                                                                                                        Suivant
                                                                                                      </Button>
                                                                                                    </ButtonGroup>
                                                                                                  </Box>
                                                                                                </> :
                                                                                                  step === 23 ?
                                                                                                    <Question23/> :
                                                                                                      step === 24 ?
                                                                                                        <Question24/> :
                                                                                                          step === 25 ?
                                                                                                            <Question25/> :
                                                                                                              step === 26 ?
                                                                                                                <Question26/> :
                                                                                                                  step === 27 ?
                                                                                                                    <Question27/> :
                                                                                                                      step === 28 ?
                                                                                                                        <Question28/> :
                                                                                                                          step === 29 ?
                                                                                                                            <Question29/> :
                                                                                                                              step === 30 ?
                                                                                                                                <Question30/> :
                                                                                                                                  step === 31 ?
                                                                                                                                    <>
                                                                                                                                      <Heading w="100%" fontSize={headingSize} textAlign={'center'} fontWeight="normal"  color={'black'}>
                                                                                                                                        Selon vous, que devrait absolument offrir une nouvelle banque mobile pour vous convaincre de l’utiliser ?
                                                                                                                                      </Heading>
                                                                                                                                      <Center p={paddingValue}>
                                                                                                                                        <Stack spacing={5} align={'center'} maxW={maxWValue} w={'full'}>
                                                                                                                                          {
                                                                                                                                              <Textarea 
                                                                                                                                                value={textAreaValue31}
                                                                                                                                                onChange={handleInputChange31}
                                                                                                                                                placeholder="Veuillez écrire votre réponse !"
                                                                                                                                                focusBorderColor="#FFD700"
                                                                                                                                                borderColor={'black'} 
                                                                                                                                              />
                                                                                                                                          }            
                                                                                                                                        </Stack>
                                                                                                                                      </Center>
                                                                                                                                      <Box mt={4} align={'center'}>
                                                                                                                                        <ButtonGroup mt={4} spacing={10}>
                                                                                                                                          <Button
                                                                                                                                            bg={'gray'}
                                                                                                                                            rounded={'full'}
                                                                                                                                            colorScheme="gray"
                                                                                                                                            size={buttonSize}
                                                                                                                                            onClick={() => {
                                                                                                                                              setStep(step - 1)
                                                                                                                                              //setProgress(45)
                                                                                                                                              setProgress(Math.round((progress - 3.33) * 100) / 100)
                                                                                                                                            }}
                                                                                                                                          >
                                                                                                                                            Retour
                                                                                                                                          </Button>
                                                                                                                                          <Button
                                                                                                                                            bg={'#FFD700'}
                                                                                                                                            rounded={'full'}
                                                                                                                                            colorScheme="yellow"
                                                                                                                                            isDisabled={textAreaValue31 === ''}
                                                                                                                                            size={buttonSize}
                                                                                                                                            onClick={() => {
                                                                                                                                              handleSubmit();
                                                                                                                                              setStep(step + 1)
                                                                                                                                              //if (active11A || active11B || active11C || active11D) setProgress(55)
                                                                                                                                              setProgress(100)
                                                                                                                                            }}
                                                                                                                                          >
                                                                                                                                            Terminer
                                                                                                                                          </Button>
                                                                                                                                        </ButtonGroup>
                                                                                                                                      </Box>
                                                                                                                                    </> :
                                                                                                                                      step === 32 &&
                                                                                                                                        <Congrats/>
        }
        
        {/* <Box mt={4} align={'center'}>
            <ButtonGroup mt={4} spacing={10}>
              {step > 2 && step < 22 && 
                <Button
                  bg={'gray'}
                  rounded={'full'}
                  colorScheme="gray"
                  onClick={() => {
                    setStep(step - 1)
                    //setProgress(progress - 5)
                  }}
                >
                  {step !== 1 ? "Retour" : <><NavLink to ="/">Retour</NavLink></>}
                </Button>
              }
              {step < 22 &&              
                <Button
                  bg={'#FFD700'}
                  rounded={'full'}
                  colorScheme="yellow"
                    onClick={() => {
                    setStep(step + 1)
                    //if (step !== 1) setProgress(progress + 5)
                  }}
                >
                  {step === 1 ? "Répondre au questionnaire" : step !== 21 ? "Suivant" : "Terminer"}
                </Button>
              }
            </ButtonGroup>
          </Box> */}
          
      </Box>
    </>
  )
}

export default Questionnaire;